export const SPRING_GENTLE = { type: 'spring' as const, stiffness: 300, damping: 30 };
export const SPRING_SNAPPY = { type: 'spring' as const, stiffness: 400, damping: 35 };
export const DURATION_FAST = 0.15;
export const DURATION_DEFAULT = 0.25;
export const DURATION_SLOW = 0.4;
export const STAGGER_GAP = 0.05;
